// import runtimeEnv from '@mars/heroku-js-runtime-env';

const env = process.env; // runtimeEnv();

window.Api = {};
window.CCApi = {};

window.Api.Base = env.REACT_APP_API_BASE
window.CCApi.Base = env.REACT_APP_CC_API_BASE
window.CCApi.FunnelFontsBase = env.REACT_APP_FONTS_BASE_API_URL

window.Api.User = {};

window.Api.User.Base = window.Api.Base + "/user"

window.Api.User.Login                 = window.Api.User.Base + "/login"
window.Api.User.Logout                = window.Api.User.Base + "/logout"
window.Api.User.Info                  = window.Api.User.Base + "/info"
window.Api.User.RequestResetPassword  = window.Api.User.Base + "/requestResetPassword"
window.Api.User.ResetPassword         = window.Api.User.Base + "/resetPassword"
window.Api.User.RefreshToken          = window.Api.User.Base + "/login/refresh"

window.Api.Register                   = window.Api.Base + "/companies/members"

window.Api.Submissions                = window.Api.Base + "/submissions"

window.Api.Images                     = window.Api.Base + "/images"
window.Api.ImagesSearch               = window.Api.Base + "/images-search"

window.Api.ContentBlocks              = window.Api.Base + "/content-blocks"

window.Api.DemoContentBlocks          = window.Api.Base + "/demoContentBlocks"

window.Api.Menus                      = window.Api.Base + "/menus"
window.Api.Footers                    = window.Api.Base + "/footers"
window.Api.Forms                      = window.Api.Base + "/forms"
window.Api.Pages                      = window.Api.Base + "/pages"
window.Api.Websites                   = window.Api.Base + "/websites"
window.Api.Hashes                     = window.Api.Base + "/hashes"
window.Api.Contacts                   = window.Api.Base + "/contacts"
window.Api.Articles                   = window.Api.Base + "/articles"
window.Api.CartItems                  = window.Api.Base + "/cart-items"
window.Api.Packages                   = window.Api.Base + "/packages"
window.Api.Fonts                      = window.Api.Base + "/fonts"
window.Api.Messages                   = window.Api.Base + "/messages"
window.Api.Files                      = window.Api.Base + "/files"
window.Api.Vouchers                   = window.Api.Base + "/vouchers"

window.Api.Services                   = window.Api.Base + "/services"
window.Api.Slots                      = window.Api.Base + "/slots"
window.Api.Homepage                   = window.Api.Base + "/websites/homepage"
window.Api.AI                         = window.Api.Base + "/ai"

window.Api.StripePubishableKey        = env.REACT_APP_STRIPE_PUBLISHABLE_KEY
window.Api.RecaptchaSiteKey           = env.REACT_APP_RECAPTCHA_SITE_KEY

window.Api.AddBlocksPageId            = env.REACT_APP_BLOCKS_PAGE_ID

window.Api.GTMID                      = env.REACT_APP_GTM_ID

window.Api.GeoLocationApi             = "https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=&longitude=&localityLanguage=en"

window.CCApi.CampaignQuery            = window.CCApi.Base + "/providersApi/v1/StoreFront/CampaignQuery"
window.CCApi.CollectionProducts       = window.CCApi.Base + "/providersApi/V1/Collection/live"
window.CCApi.Products                 = window.CCApi.Base + "/providersApi/v1/StoreFront/ProductQuery"
window.CCApi.ExchangeRate             = window.CCApi.Base + "/providersApi/v1/Currency/exchangerate"
window.CCApi.Save                     = window.CCApi.Base + "/storefrontApi/v1/funnel/save"
window.CCApi.Pages                    = window.CCApi.Base + "/storefrontApi/v1/funnel/pages"
window.CCApi.Assets                   = window.CCApi.Base + "/api/V1/Asset"
window.CCApi.Links                    = window.CCApi.Base + "/storefrontApi/v1/funnel/links"
window.CCApi.Thumbnail                = window.CCApi.Base + "/storefrontApi/v1/funnel/thumbnail"
window.CCApi.FunnelFontsUrl           = window.CCApi.FunnelFontsBase + "/FunnelFont/GetFonts"
window.CCApi.LeadSubmit               = window.CCApi.Base + "/providersApi/V1/Import/Lead"
